
import React from 'react';
import { Base64 } from 'js-base64';
import { formatMoneyCurrency } from '../../../../utils/currency';
import { useDispatch, useSelector } from 'react-redux';
import { IHotelsState, ILoginState } from '@share/store/slices';
import { HeartTwoTone } from '@ant-design/icons';
import { handleSavedProperties } from '@store/slices';
import { ISavedProperties } from '@common-types';
import { HotelStars, WalletMessage } from '@components';
import { FormattedMessage, useIntl } from 'react-intl';
import { renderNumber } from '@share/utils';
import { IAccount, IUserWallet } from '@share/common-types';
import { getWalletPrices, WalletPriceType } from '@utils';
import { BlueButton } from '@share/components';

import moment from 'moment';

import { withRouter, RouteComponentProps } from 'react-router-dom';

import { get } from 'lodash';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';

import { IHotelInfo } from '@common-types';
import { IClientCash, IHotel } from '@share/common-types';
import { RootState } from '@share/utils';

import { hotelsActions, ILocationsState, IMarginatorState, marginatorActions, IMenuState } from '@share/store/slices';
import { roomsSearchActions, hotelDetailsActions } from '@store/slices';

interface IMapStateToProps {
  menuStore: IMenuState;
  hotelsStore: IHotelsState;
  loginStore: ILoginState;
  locationsStore: ILocationsState;
  marginatorStore: IMarginatorState;
}

interface IMapDispatchToProps {
  setCommission: (value: number) => void;
  setSupplier: (value: string) => void;
  setHotelDetails: (hotel: IHotelInfo | null | undefined) => void;
  setSelectedHotel: (hotel: IHotel) => void;
  setSelectedHotelSearchClientCash: (selectedClientCash: IClientCash) => void;
  resetState: () => void;
}

interface IProps extends IMapStateToProps, IMapDispatchToProps, RouteComponentProps {
  images: any,
  details: any,
  decryptedData: any,
  hotelId: any,
  sessionKey: any,
  counters: any,



  hotel: IHotel;
  nights: number;
  matches?: boolean;
  isFromSearch?: boolean;
  isSimilar?: boolean;
  disabled?: boolean;
  compared?: boolean;
  displayCompare?: boolean;
  disableCompare?: boolean;
  isVacationRentals?: boolean | null | undefined;
}

const zero = 0;
const percents = 100;

function HotelCardComponent(props: IProps) {

  const { details, sessionKey } = props;

  const login = useSelector((state: IMapStateToProps) => state.loginStore);
  const dispatch = useDispatch();

  const dateObject = {
    checkIn: props.decryptedData.hotelsRequest.checkIn,
    checkOut: props.decryptedData.hotelsRequest.checkOut,
  };

  const handleSubmit = (selectedPropertyClientCash: number) => {
    const { selectedHotelSearchClientCash } = hotelsStore;

    const clientCash: any = { ...selectedHotelSearchClientCash, selectedPropertyClientCash, selectedPropertyReviewClientCash: null };
    props.setSelectedHotelSearchClientCash(clientCash);

    history.push(
      `/${login?.account?.name}/hotel/${hotelId}?dates=${Base64.encode(
        JSON.stringify(dateObject),
      )}&rooms=${Base64.encode(
        JSON.stringify(props.decryptedData.hotelsRequest.rooms),
      )}&location=${Base64.encode(
        JSON.stringify(props.decryptedData.hotelsRequest.location),
      )}&sessionKey=${Base64.encode(JSON.stringify(sessionKey))}`,
    );
  };

  const formatter = formatMoneyCurrency(props.details.currency);

  const handleSavedProperty = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    const prop: ISavedProperties = {
      propertyId: Number(hotelId),
      imgSrc: images[0].url,
      name: props.details.name,
      address: props.details.location,
      rating: props.details.guestReviews,
      reviewsCount: props.details.guestReviewsCount
    }
    dispatch(handleSavedProperties(prop));
  };

  const getMinPublicPrice = (): number => {
    const { publicPrices } = props.hotel;

    if (publicPrices && publicPrices.length) {
      return Math.min(...publicPrices.map(({ price }) => price));
    }

    return zero;
  };

  const { hotel, nights, loginStore, hotelsStore, history } = props;
  const {
    images,
    price,
    possibleStays,
    maxWalletClientCash,
    hotelId
  } = hotel;

  const { account, userWalletData } = loginStore;
  const { selectedHotelSearchClientCash } = hotelsStore;

  const pubPrice = getMinPublicPrice();

  const { value } = props.marginatorStore;
  const marginatorPrice = price / (1 - (value / 100));
  const marginatorSavings = pubPrice - marginatorPrice;
  const msave = pubPrice ? (marginatorPrice * percents) / pubPrice : 100;
  const marginatorsavePercents = Math.floor(percents - msave);

  const nightsCount = !possibleStays?.length ? nights : moment(possibleStays[0].checkOut).diff(moment(possibleStays[0].checkIn), 'days')

  const hotelPrices = getWalletPrices(account as IAccount, userWalletData as IUserWallet, selectedHotelSearchClientCash, marginatorPrice, maxWalletClientCash, WalletPriceType.Search);

  const displayWalletSavings = account?.walletWalletSavings && (hotelPrices?.priceSavings > 0 || hotelPrices?.maxClientCashAmountAllow > 0) && !!hotelPrices?.maxClientCashAmountAllow;

  const clientCashApplied = hotelPrices?.clientCashApplied;
  const marginatorPriceFinal = displayWalletSavings ? hotelPrices?.priceFinalMax : hotelPrices?.priceFinal;

  const intl = useIntl();
  return (
    <div className="vstack gap-4">
      <div className="card custom-hotel-card shadow p-2" style={{ marginBottom: '32px' }}>
        <div className="row g-0 pt-2 pb-2 ps-2">
          <div className="col-md-5 position-relative ps-0">
            <div className="position-absolute top-0 start-0 z-index-1 m-2">
              <div className="badge text-bg-success">
                <FormattedMessage id="save" /> {Math.floor(marginatorsavePercents)}%
              </div>
            </div>

            <div className="tiny-slider arrow-round arrow-xs arrow-dark overflow-hidden rounded-2" style={{ 
              height: '100%', 
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              backgroundImage: `url(${get(images, '[0].url')})` }}>
            </div>
          </div>

          <div className="col-md-7">
            <div className="card-body px-md-0 py-md-2 d-flex flex-column h-100 position-relative">
              <div className="d-flex justify-content-between align-items-center">
                {details?.ratingStars > 0 && (
                  <h4 className="hotel-card-wrapper__hotel-info-title">
                    <HotelStars stars={details.ratingStars} />
                  </h4>
                )}
                <ul className="list-inline mb-0">
                  <li className="list-inline-item">
                    <a href="#" role="button" onClick={(e) => handleSavedProperty(e)}>
                      <HeartTwoTone
                        twoToneColor={details.savedProperty ? '#f40b0b' : '#c2c2c2'}
                        style={{ fontSize: 'larger' }}
                      />
                    </a>
                  </li>
                </ul>
              </div>

              <h5 className="card-title mb-1">{details?.name}</h5>

              <p>
                <i className="bi bi-geo-alt me-2"></i>
                {details?.location}
              </p>

              <div className="d-sm-flex justify-content-sm-between align-items-center mt-md-auto">
                <div className="d-flex flex-column justify-content-start height-full">
                  <ul className="nav mt-2 mb-2">
                    <li className="nav-item rating">{details?.guestReviews?.toFixed(1)}</li>
                    <li className="nav-item pt-1 mx-2 public_price">
                      ({details?.guestReviewsCount} <FormattedMessage id="reviews" />)
                    </li>
                  </ul>
                </div>
                <div className="mt-3 mt-sm-0 text-sm-end pb-2">
                  {displayWalletSavings ? (
                    <div className="hotel-card-wrapper__price-savings">
                      <p className="hotel-card-wrapper__savings-text" style={{ marginRight: '6px' }}>
                        <FormattedMessage id="wallet.save.up.to.max" values={{ clientCashName: account?.walletClientCashName }} />
                      </p>
                      {hotelPrices?.maxClientCashAmountAllow >= 1 ? (
                        <p className="hotel-card-wrapper__savings-text value-amount" style={{ whiteSpace: 'nowrap' }}>
                          {renderNumber(hotelPrices?.maxClientCashAmountAllow)}
                        </p>) : (
                        <p className="hotel-card-wrapper__savings-text value-amount" style={{ whiteSpace: 'nowrap' }}>
                          &lt;{renderNumber(1)}
                        </p>)}
                    </div>) : null}

                  {(!account?.walletWalletSavings && !account?.isMLM) ? (
                    <WalletMessage
                      price={details?.totalPrice}
                      maxClientCash={details?.maxWalletClientCash}
                      currency={details?.currency}
                      type={WalletPriceType.Search}
                      isOneLine
                      isShort
                      style={{ paddingTop: '0px !important' }}
                    />) : null}

                </div>
              </div>

              <div className="d-sm-flex justify-content-sm-between align-items-center mt-3 mt-md-auto">
                <div className="d-flex flex-column justify-content-end height-full">
                  <div className="public_price">
                    <span className="me-2"><FormattedMessage id="result.hotel.card.public" /></span>
                    <span className="text-decoration-line-through mb-0">
                      {formatter.format(details?.public_price)}
                    </span>
                  </div>
                  <span className="savings-text fw-bold mt-2">
                    <FormattedMessage id="savings" /> {formatter.format(Math.abs(marginatorSavings))}
                  </span>

                  <div className="d-flex align-items-center mt-2">
                    <h5 className="fw-bold mb-0">
                      {formatter.format(details?.pricePerNight)}
                      {/* {details.currency} {details?.pricePerNight.toLocaleString()} */}
                    </h5>
                    <span className="mb-0">/ <FormattedMessage id="night" /></span>
                  </div>
                </div>

                <div className="mt-3 mt-sm-0 text-sm-end pb-0">
                  {details.refundable === 'nonrefundable' && (
                    <ul className="list-group list-group-borderless small mb-0 mt-2">
                      <li className="list-group-item d-flex text-danger p-0">
                        <i className="bi bi-patch-check-fill me-2"></i>
                        <FormattedMessage id="hotel.non.refundable" />
                      </li>
                    </ul>
                  )}
                  {details?.refundable === 'refundable' && (
                    <ul className="list-group list-group-borderless small mb-0 mt-0">
                      <li className="list-group-item d-flex text-success p-0">
                        <i className="bi bi-patch-check-fill me-2"></i>
                        <FormattedMessage id="hotel.refundable" />
                      </li>
                    </ul>
                  )}
                  <div className="mb-2 pb-0 mt-2">
                    {formatter.format(marginatorPriceFinal)} {intl.formatMessage({ id: 'for' })} {nightsCount}{' '}
                    {Math.round(details?.public_price / details.pricePerNight) > 1
                      ? (intl.formatMessage({ id: 'small.nights.title' }))
                      : (intl.formatMessage({ id: 'night' }))}
                  </div>
                  <BlueButton
                    block
                    size="large"
                    type="primary"
                    htmlType="submit"
                    className="btn btn-primary mb-0 mt-0 commonBlueBtn-small ms-auto"
                    onClick={() => handleSubmit(clientCashApplied)}
                  >
                    <FormattedMessage id="view.details" />
                  </BlueButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    menuStore: state.navigationMenuStore,
    hotelsStore: state.hotelsStore,
    loginStore: state.loginStore,
    locationsStore: state.locationsStore,
    marginatorStore: state.marginatorStore
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<RootState, undefined, Action>): IMapDispatchToProps => ({
  setCommission: (value: number) => {
    dispatch(marginatorActions.setCommission(value));
  },
  setSupplier: (value: string) => {
    dispatch(marginatorActions.setSupplier(value));
  },
  setHotelDetails: (hotel: IHotelInfo | null | undefined) => {
    dispatch(hotelDetailsActions.setHotelDetails(hotel));
  },
  setSelectedHotel: (hotel: IHotel) => {
    dispatch(hotelsActions.setSelectedHotel(hotel));
  },
  resetState: () => {
    dispatch(roomsSearchActions.resetState());
  },
  setSelectedHotelSearchClientCash: (selectedClientCash: IClientCash) => {
    dispatch(hotelsActions.setSelectedHotelSearchClientCash(selectedClientCash));
  },
});

const HotelCardWrapperRouter = withRouter(HotelCardComponent);

const HotelCard = connect(mapStateToProps, mapDispatchToProps)(HotelCardWrapperRouter);
export default HotelCard;